import { createPortal } from 'react-dom';
import clsx from 'clsx';
import styles from './BulkAddModal.module.scss';
import { crossBtnGrey } from '../../assets/hostedassets';
import Button from '../_custom/Button/Button';
import { useBulkAddModalLogic } from './useBulkAddModalLogic';
import { BULK_ADD_INPUT_HINT } from './constants';

// NOTE: preserves the pre-existing hand-rolled modal/backdrop pattern extracted verbatim from GlobalSearch; consolidation onto _custom/Modal deferred to keep this temporary outage guard visually/behaviorally identical.

type BulkAddModalProps = {
    initialText?: string;
    onClose: () => void;
};

/**
 * Shared Bulk Add modal — extracted from GlobalSearch so the manual "Bulk Add" button and any
 * rerouted Add Lead mount points (Karza-outage guard) render/submit identically.
 */
const BulkAddModal = ({ initialText = '', onClose }: BulkAddModalProps) => {
    const { bulkText, setBulkText, bulkLoading, handleBulkConfirm, hasUserEditedRef } = useBulkAddModalLogic(initialText, onClose);

    return createPortal(
        <div className={styles.BulkBackdrop}>
            <div className={styles.BulkModal}>
                <div className={styles.BulkHeader}>
                    <h2 className={styles.BulkTitle}>Bulk Add</h2>

                    <button type="button" aria-label="Close" className={styles.BulkClose} onClick={onClose}>
                        <img src={crossBtnGrey} alt="close" className={styles.BulkCloseIcon} />
                    </button>
                </div>
                <div>
                    {bulkText.trim() && <div className={styles.BulkSubtitle}>{BULK_ADD_INPUT_HINT}.</div>}
                    <textarea
                        autoFocus
                        className={clsx(styles.BulkTextarea, bulkText.trim() && styles.BulkTextareaFilled)}
                        value={bulkText}
                        placeholder={BULK_ADD_INPUT_HINT}
                        onChange={(e) => {
                            hasUserEditedRef.current = true;
                            setBulkText(e.target.value);
                        }}
                    />
                </div>
                <Button
                    text="Confirm"
                    disabled={!bulkText.trim()}
                    loading={bulkLoading}
                    onClick={handleBulkConfirm}
                    variant="purple"
                    size="wide"
                    className={styles.BulkConfirmButton}
                />
            </div>
        </div>,
        document.body,
    );
};

export default BulkAddModal;
